import { Component, OnInit } from '@angular/core';
import { AnalyticsConstants } from '../../../shared/constants/Analytics';
import { NoticeDto } from '../../../shared/models/admin/notice.dto';
import { NoticesService } from '../../../shared/services/admin/notices.service';
import { TrackAnalyticsService } from '../../../shared/services/track-analytics/track-analytics.service';

@Component({
  selector: 'ngx-notices-badge',
  templateUrl: './notices-badge.component.html',
  styleUrls: ['./notices-badge.component.scss'],
})
export class NoticesBadgeComponent implements OnInit {
  notices: NoticeDto[];

  constructor(
    private readonly noticesService: NoticesService,
    private readonly trackAnalytics: TrackAnalyticsService
  ) {
    this.notices = [];
    this.notices = this.noticesService.readNotices();
  }

  ngOnInit() {
    this.noticesService.notices.subscribe((notices: NoticeDto[]) => {
      this.notices = notices;
    });
  }
  sendAnalytic(): void {
    this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_FEATURE,  AnalyticsConstants.READ_NOTICES_URL);
  }

  private getNotices(): void {

  }

}
